import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mm-mob"
}
const _hoisted_2 = { class: "mm-list" }
const _hoisted_3 = {
  key: 0,
  class: "mm-empty"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mm-card-nume" }
const _hoisted_6 = { class: "mm-card-actiuni" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "mm-mob-head" }
const _hoisted_10 = { class: "mm-list" }
const _hoisted_11 = {
  key: 0,
  class: "mm-empty"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "mm-card-nume" }
const _hoisted_14 = { class: "mm-card-actiuni" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mm-title" }
const _hoisted_17 = { class: "mm-footer" }
const _hoisted_18 = {
  key: 1,
  class: "mm-split"
}
const _hoisted_19 = { class: "mm-pane mm-left" }
const _hoisted_20 = { class: "mm-pane mm-right" }
const _hoisted_21 = { class: "mm-pane-title" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "mm-empty-desk"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxRequiredRuleStd = _resolveComponent("DxRequiredRuleStd")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxFormStd = _resolveComponent("DxFormStd")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxPopupStd = _resolveComponent("DxPopupStd")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_ctx.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.mobMarca)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mm-mob-head" }, "Mărci", -1)),
              _createElementVNode("div", _hoisted_2, [
                (!_ctx.marci.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Nicio marcă."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marci, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.ID,
                    class: "mm-card",
                    onClick: ($event: any) => (_ctx.openModele(m))
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(m.Nume), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "mm-ic edit",
                        title: "Editează",
                        onClick: _withModifiers(($event: any) => (_ctx.editMarca(m)), ["stop"])
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "dx-icon dx-icon-edit" }, null, -1)
                      ]))], 8, _hoisted_7),
                      _createElementVNode("button", {
                        class: "mm-ic del",
                        title: "Șterge",
                        onClick: _withModifiers(($event: any) => (_ctx.delMarca(m)), ["stop"])
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "dx-icon dx-icon-trash" }, null, -1)
                      ]))], 8, _hoisted_8),
                      _cache[7] || (_cache[7] = _createElementVNode("i", { class: "dx-icon dx-icon-chevronright mm-chev" }, null, -1))
                    ])
                  ], 8, _hoisted_4))
                }), 128))
              ]),
              _createElementVNode("button", {
                class: "mm-fab",
                title: "Adaugă marcă",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addMarca && _ctx.addMarca(...args)))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "dx-icon dx-icon-plus" }, null, -1)
              ]))])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "mm-mob-back",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mobMarca = null))
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "dx-icon dx-icon-chevronleft" }, null, -1),
                _createElementVNode("span", null, "Mărci", -1)
              ]))]),
              _createElementVNode("div", _hoisted_9, "Modele — " + _toDisplayString(_ctx.mobMarca.Nume), 1),
              _createElementVNode("div", _hoisted_10, [
                (!_ctx.modele.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Niciun model."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modele, (mo) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: mo.ID,
                    class: "mm-card",
                    onClick: ($event: any) => (_ctx.editModel(mo))
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(mo.Nume), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "mm-ic del",
                        title: "Șterge",
                        onClick: _withModifiers(($event: any) => (_ctx.delModel(mo)), ["stop"])
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("i", { class: "dx-icon dx-icon-trash" }, null, -1)
                      ]))], 8, _hoisted_15)
                    ])
                  ], 8, _hoisted_12))
                }), 128))
              ]),
              _createElementVNode("button", {
                class: "mm-fab",
                title: "Adaugă model",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addModel && _ctx.addModel(...args)))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "dx-icon dx-icon-plus" }, null, -1)
              ]))])
            ], 64)),
        _createVNode(_component_DxPopupStd, {
          visible: _ctx.popupVisible,
          "show-title": true,
          "full-screen": true,
          height: "auto",
          "close-on-outside-click": false,
          "show-close-button": true,
          onHidden: _cache[4] || (_cache[4] = ($event: any) => (_ctx.popupVisible = false))
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.popupTitle), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxFormStd, {
              ref: "formRef",
              "form-data": _ctx.formData,
              "col-count": 1,
              "label-location": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSimpleItem, {
                  "data-field": "Nume",
                  label: { text: 'Nume' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRuleStd, { message: "Numele este obligatoriu" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["form-data"]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "default",
                icon: "save",
                width: "120",
                disabled: _ctx.isSaving,
                onClick: _ctx.onSave
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                type: "normal",
                "styling-mode": "outlined",
                width: "120",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popupVisible = false))
              })
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mm-pane-title" }, "Mărci", -1)),
          _createVNode(_component_DxDataGrid, {
            ref: "marcaGrid",
            "data-source": _ctx.dsMarca,
            "key-expr": "ID",
            height: "100%",
            "show-borders": true,
            "show-column-lines": false,
            "show-row-lines": true,
            "row-alternation-enabled": true,
            "hover-state-enabled": true,
            onSelectionChanged: _ctx.onMarcaSelected,
            onInitNewRow: _ctx.onInitMarca
          }, {
            marcaTitle: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createElementVNode("div", { class: "mm-title" }, "Marcă", -1)
            ]))]),
            default: _withCtx(() => [
              _createVNode(_component_DxSelection, { mode: "single" }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxSearchPanel, {
                visible: true,
                placeholder: "Caută..."
              }),
              _createVNode(_component_DxPaging, { "page-size": 15 }),
              _createVNode(_component_DxSorting, { mode: "multiple" }),
              _createVNode(_component_DxEditing, {
                "allow-adding": true,
                "allow-updating": true,
                "allow-deleting": true,
                mode: "popup"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxPopup, {
                    "show-title": true,
                    width: 400,
                    height: "auto",
                    "title-template": "marcaTitle",
                    "close-on-outside-click": false
                  }),
                  _createVNode(_component_DxForm, { "col-count": 1 })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "ID",
                caption: "ID",
                width: 70,
                "allow-editing": false,
                visible: false,
                "form-item": { visible: false }
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Nume",
                caption: "Nume"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Numele este obligatoriu" })
                ]),
                _: 1
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "Cod",
                caption: "Cod",
                width: 90,
                visible: false,
                "form-item": { visible: false }
              }),
              _createVNode(_component_DxToolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, { name: "addRowButton" }),
                  _createVNode(_component_DxItem, { name: "searchPanel" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data-source", "onSelectionChanged", "onInitNewRow"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[15] || (_cache[15] = _createTextVNode(" Modele", -1)),
            (_ctx.marcaNume)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, " — " + _toDisplayString(_ctx.marcaNume), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.selectedMarcaId)
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 0,
                ref: "modelGrid",
                "data-source": _ctx.dsModel,
                "key-expr": "ID",
                height: "100%",
                "show-borders": true,
                "show-column-lines": false,
                "show-row-lines": true,
                "row-alternation-enabled": true,
                "hover-state-enabled": true,
                onInitNewRow: _ctx.onInitModel
              }, {
                modelTitle: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("div", { class: "mm-title" }, "Model", -1)
                ]))]),
                default: _withCtx(() => [
                  _createVNode(_component_DxFilterRow, { visible: true }),
                  _createVNode(_component_DxSearchPanel, {
                    visible: true,
                    placeholder: "Caută..."
                  }),
                  _createVNode(_component_DxPaging, { "page-size": 15 }),
                  _createVNode(_component_DxSorting, { mode: "multiple" }),
                  _createVNode(_component_DxEditing, {
                    "allow-adding": true,
                    "allow-updating": true,
                    "allow-deleting": true,
                    mode: "popup"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxPopup, {
                        "show-title": true,
                        width: 400,
                        height: "auto",
                        "title-template": "modelTitle",
                        "close-on-outside-click": false
                      }),
                      _createVNode(_component_DxForm, { "col-count": 1 })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "ID",
                    caption: "ID",
                    width: 70,
                    "allow-editing": false,
                    visible: false,
                    "form-item": { visible: false }
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Nume",
                    caption: "Nume"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Numele este obligatoriu" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "Cod",
                    caption: "Cod",
                    width: 90,
                    visible: false,
                    "form-item": { visible: false }
                  }),
                  _createVNode(_component_DxToolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxItem, { name: "addRowButton" }),
                      _createVNode(_component_DxItem, { name: "searchPanel" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data-source", "onInitNewRow"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[17] || (_cache[17] = [
                _createElementVNode("i", { class: "dx-icon dx-icon-car mm-empty-icon" }, null, -1),
                _createElementVNode("span", null, "Selectează o marcă pentru a-i vedea modelele.", -1)
              ]))]))
        ])
      ]))
}